export default __webpack_public_path__ + "images/KQ.8d19d08.png";